import { createReducer, createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  // authenticate: ["provider", "credentials"],
  authenticate: ["user", "token", "redirect"],
  setCurrentUser: ["user"],
  toggleImpersonateUser: ["userId", "redirect"],
  toggleImpersonateUserSuccess: ["userId"],
  cleanUpSession: null,
  signUp: ["user", "redirect"],
  signUpError: ["error"],
  restoreSession: null,
});

export const AuthTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = {
  isLoggingIn: false,
  isImpersonationChanging: null,
  impersonationTarget: null,
  currentUser: {
    uid: null,
    displayName: "",
    photoURL: "",
    email: null,
    phoneNumber: null,
    providerId: null,
  },
};

/* ------------- Selectors ------------- */

export const AuthSelectors = {
  isImpersonating: (state) => !!state.auth.impersonationTarget,
  isImpersonationChanging: (state) => state.auth.isImpersonationChanging,
  currentUser: (state) => ({
    ...state.user.user, // TODO: remove this guy in order of auth.currentUser
    ...state.auth.currentUser,
  }),
};

/* ------------- Reducers ------------- */

export const authenticate = (state = INITIAL_STATE) => ({
  ...state,
  isLoggingIn: true,
});

export const cleanUpSession = () => INITIAL_STATE;

export const restoreSession = () => INITIAL_STATE;

export const setCurrentUser = (state = INITIAL_STATE, action) => ({
  ...state,
  currentUser: action.user,
  isLoggingIn: false,
});

export const toggleImpersonateUser = (state = INITIAL_STATE, action) => ({
  ...state,
  isImpersonationChanging: action.userId,
});

export const toggleImpersonateUserSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  isImpersonationChanging: null,
  impersonationTarget: action.userId,
});

export const signUp = (state = INITIAL_STATE) => ({
  ...state,
  isLoggingIn: true,
});

export const signUpError = (state = INITIAL_STATE) => ({
  ...state,
  isLoggingIn: false,
});


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.AUTHENTICATE]: authenticate,
  [Types.CLEAN_UP_SESSION]: cleanUpSession,
  [Types.SET_CURRENT_USER]: setCurrentUser,
  [Types.TOGGLE_IMPERSONATE_USER]: toggleImpersonateUser,
  [Types.TOGGLE_IMPERSONATE_USER_SUCCESS]: toggleImpersonateUserSuccess,
  [Types.SIGN_UP]: signUp,
  [Types.SIGN_UP_ERROR]: signUpError,
  [Types.RESTORE_SESSION]: restoreSession,
});
